import {UHC_COOKIE} from 'constants/uhc';
import {logWithSentry} from 'libs/sentry/sentry';
import {cookieStore} from 'libs/storage/storage';

/**
 * Return UHC network name
 *
 * @returns {string} network name
 */
export const getCurrentUhcCookie = (): keyof typeof UHC_COOKIE.VALUES => {
    const currentUhcCookie = cookieStore.get(UHC_COOKIE.KEY);

    if (!currentUhcCookie) {
        logWithSentry(new Error(`${UHC_COOKIE.KEY} cookie is not defined.`), UHC_COOKIE);
    }

    return currentUhcCookie;
};
